import styled from 'styled-components';
import { rem } from 'polished';

const StyledNotifications = styled.span`
  background-color: ${props => props.theme.colors.transparent};
  border-radius: ${rem('10px')};
  color: #fcc400;
  pointer-events: none;
  display: inline-block;
  font-family: ${props => props.theme.fonts.bold};
  font-size: 1rem;
  height: ${rem('21px')};
  line-height: ${rem('15px')};
  min-width: ${rem('21px')};
  padding: 0.1875rem 1.2rem;
  text-align: center;
`;

export { StyledNotifications };
